import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { Capacitor } from "@capacitor/core";

import { AppModule } from "./app/app.module";
import { registerAppIcons } from "./app/shared/icons/app-icons";
import { environment } from "./environments/environment";
import { initializeSentryMonitoring } from "./sentry";
import packageJson from "../package.json";

registerAppIcons();

if (environment.production) {
  enableProdMode();
}

initializeSentryMonitoring(
  environment,
  `finn@${packageJson.version}`,
  Capacitor.getPlatform()
);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));

defineCustomElements(window);
